var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconAccessibility40(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2241_9357)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0001 4.44673C28.5914 4.44673 35.556 11.4114 35.556 20.0027C35.556 28.594 28.5914 35.5587 20.0001 35.5587C11.4087 35.5587 4.44409 28.594 4.44409 20.0027C4.44409 11.4114 11.4087 4.44673 20.0001 4.44673ZM12.7116 13.7803C11.9948 13.7803 11.4138 14.3559 11.4138 15.0658C11.4138 15.8708 12.027 16.5461 12.8351 16.6313L16.7868 17.0478H17.3654V22.3729L15.1069 29.6896C14.8934 30.3815 15.2865 31.1138 15.985 31.3254C16.6836 31.5369 17.4229 31.1475 17.6365 30.4556L19.9555 22.9427H20.1237L22.4427 30.4556C22.6563 31.1475 23.3957 31.5369 24.0942 31.3254C24.7927 31.1138 25.1858 30.3815 24.9723 29.6896L22.6557 22.1845V17.0478H23.2343L27.186 16.6313C27.9941 16.5461 28.6073 15.8708 28.6073 15.0658C28.6073 15.0244 28.6053 14.9831 28.6012 14.942C28.5322 14.2354 27.898 13.718 27.1846 13.7864L22.697 14.2163H17.3241L12.8365 13.7864C12.795 13.7824 12.7533 13.7803 12.7116 13.7803ZM20.0105 8.98061C18.9149 8.98061 18.0267 9.86036 18.0267 10.9456C18.0267 12.0308 18.9149 12.9105 20.0105 12.9105C21.1062 12.9105 21.9944 12.0308 21.9944 10.9456C21.9944 9.86036 21.1062 8.98061 20.0105 8.98061Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0105 12.9105C21.1061 12.9105 21.9943 12.0308 21.9943 10.9456C21.9943 9.86037 21.1061 8.98062 20.0105 8.98062C18.9148 8.98062 18.0266 9.86037 18.0266 10.9456C18.0266 12.0308 18.9148 12.9105 20.0105 12.9105Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1234 22.9427H19.9553L17.6362 30.4556C17.4227 31.1475 16.6833 31.5369 15.9848 31.3254C15.2863 31.1138 14.8931 30.3815 15.1067 29.6896L17.3651 22.3729V17.0478H16.7865L12.8349 16.6313C12.0267 16.5461 11.4136 15.8708 11.4136 15.0658C11.4136 14.3559 11.9946 13.7803 12.7113 13.7803C12.753 13.7803 12.7947 13.7824 12.8363 13.7864L17.3238 14.2164H22.6968L27.1843 13.7864C27.8977 13.718 28.532 14.2354 28.601 14.942C28.605 14.9832 28.607 15.0245 28.607 15.0658C28.607 15.8708 27.9939 16.5461 27.1857 16.6313L23.2341 17.0478H22.6554V22.1846L24.972 29.6896C25.1856 30.3815 24.7924 31.1138 24.0939 31.3254C23.3954 31.5369 22.656 31.1475 22.4425 30.4556L20.1234 22.9427Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2241_9357"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0 0.00268555)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconAccessibility40);
export default __webpack_public_path__ + "static/media/pictogramBeaconAccessibility40.74b07952fd343c6b9ddcd541bd046a83.svg";
export { ForwardRef as ReactComponent };